import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const RtbSourcesPage = () =>
  import('@/apps/adok/pages/rtb-sources').then((m) => m.RtbSourcesPage)

/**
 * `/advertising/rtb-sources` is the interim path this lived on, kept as a redirect so
 * links handed around meanwhile still land.
 */
const marketplaceRoutes: RouteRecordRaw[] = [
  {
    path: '/advertising/marketplace',
    component: Layout,
    children: [
      {
        path: '',
        name: 'marketplace',
        component: RtbSourcesPage,
        meta: { title: 'Marketplace' }
      },
      {
        path: 'configure',
        name: 'marketplace-configure',
        component: RtbSourcesPage,
        meta: { title: 'Configure your spots', hidden: true }
      }
    ]
  },
  {
    path: '/advertising/rtb-sources',
    redirect: '/advertising/marketplace',
    meta: { hidden: true }
  }
]

export default marketplaceRoutes
